// extracted by mini-css-extract-plugin
module.exports = {"Label":"LabelField_Label__1LO9a","sizeNormal":"LabelField_sizeNormal__1MNST","sizeMin":"LabelField_sizeMin__1EBj7"};